const showCounterIfLessThan = 5;

export const getSpotsLeftText = (spotsLeftNum?: number, attendeesLimit?: number, defaultLimitText = 'Limited Spots') => {
	if (typeof spotsLeftNum !== 'number' || typeof attendeesLimit !== 'number') {
		return;
	}

	// limit is very large, we don't want to show spots left
	if (attendeesLimit >= 1_000_000 || spotsLeftNum >= 1_000_000) {
		return;
	}

	// dont show spots left if limit is 0 or less
	if (spotsLeftNum <= 0) {
		return 'Sold out';
	}

	// show count if less than constant
	if (spotsLeftNum < showCounterIfLessThan) {
		return `${spotsLeftNum} spots left`;
	}

	// show few spots left if less than 20% of total spots
	const twentyPercentOfTotalSpots = attendeesLimit * 0.2;

	if (spotsLeftNum < twentyPercentOfTotalSpots) {
		return 'few spots left';
	}

	return defaultLimitText;
};
